import { Col, Row } from "react-bootstrap";
import IResolvedRegisterDTO from "../../../../shared/oversight-core/dtos/response-dtos/resolved-register-dto";
import styles from "./live-telemetry-register-card.module.scss";

interface IProps {
  register: IResolvedRegisterDTO;
}

const formatDisplayValue = (value: number) => {
  if (!Number.isFinite(value)) {
    return "-";
  }

  return Number.isInteger(value)
    ? value.toString()
    : value.toFixed(4).replace(/\.?0+$/, "");
};

const LiveTelemetryRegisterCard = ({ register }: IProps) => {
  return (
    <div className={`${styles.card} rounded-3 p-3 h-100`}>
      <Row>
        <Col className={`text-light font-weight-400 font-size-14`}>
          {register.defined
            ? `${register.label}(${register.unit})`
            : register.registerKey}
        </Col>
      </Row>
      <Row className="mt-1">
        <Col className={`${styles.value} font-weight-600 font-size-16`}>
          {formatDisplayValue(
            Number(
              register.defined ? register.displayValue : register.rawValue,
            ),
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LiveTelemetryRegisterCard;
